import { Component, Injectable, OnInit, TemplateRef } from '@angular/core';

import { ToastrService } from 'ngx-toastr';

import * as _ from 'lodash';
import { CommonService } from '../../../../../common/services/Common.service';
import { UploadService } from '../../../../../common/services/Upload.service';
import { ChatService } from '../../../../../common/services/Chat.service';
import { EmailService } from '../../../../../common/services/Email.service';
import { BsModalService } from 'ngx-bootstrap';

declare var $: any;

@Component({
  moduleId: module.id,
  selector: 'email-config',
  templateUrl: './mail.component.html',
  styleUrls: ['./mail.css'],
  providers: [CommonService, EmailService, BsModalService],
})
@Injectable()
export class EmailComponent implements OnInit {
  public model: any = {};
  public modelTemplate: any = {};
  public user: any = {};
  public tab = 'account';

  public list: any = [];
  public listAccount: any = [];
  public totalItem = 0;
  public totalAccount = 0;
  public message: { class: string; content: string } = null;
  public typeModal: string;
  public modalRef: any = {};
  public modalRef2: any = {};
  public id_delete: number;
  public files: any = [];
  public allTemplate: any = [];
  public allType: any = [];

  constructor(
    private commonService: CommonService,
    private uploadService: UploadService,
    private chatService: ChatService,
    private emailService: EmailService,
    private modalService: BsModalService,
    private toastr: ToastrService
  ) {
    this.user = JSON.parse(localStorage.getItem('User'));
  }

  ngOnInit() {
    this.loadAccount();
    this.loadTemplate();
  }

  changedTab(tab) {
    this.tab = tab;
    if (this.tab == 'account') {
      this.loadAccount();
    } else {
      this.loadTemplate();
    }
  }

  loadAccount(request: any = {}, sort: any = {}) {
    this.listAccount = [];
    this.emailService
      .listAccount(request)
      .toPromise()
      .then(res => {
        if (res.status == 200 && res.error == false) {
          this.listAccount = res.data;
          this.totalAccount = this.listAccount.length;
        }
      });
  }

  loadTemplate(request: any = {}, sort: any = {}) {
    const templateList = [
      {
        id: '',
        text: '',
      },
    ];
    this.emailService
      .listTemplate(request)
      .toPromise()
      .then(res => {
        if (res.status == 200 && res.error == false) {
          this.list = res.data;
          this.totalItem = this.list.length;
          this.list.forEach(e => {
            templateList.push({
              id: e.id,
              text: e.template_name,
            });
          });

          this.allTemplate = templateList;
        }
      });
  }

  openModalTemplate(template: TemplateRef<any>, id?: any) {
    this.message = null;
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-lg',
    };
    this.modalRef = this.modalService.show(template, config);
    this.modelTemplate = {};
    this.typeModal = id ? 'edit' : 'add';
    if (id) {
      this.emailService
        .findTemplate(id)
        .toPromise()
        .then(rs => {
          console.log(id, rs.data);
          this.modelTemplate = rs.data;
          this.files = this.modelTemplate.ATTACH_FILE.split(',');
        });
    }
  }

  addTemplate() {
    if (
      !this.modelTemplate.TEMPLATE_NAME ||
      (this.modelTemplate.TEMPLATE_NAME && this.modelTemplate.TEMPLATE_NAME.trim() == '')
    ) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Tên không được bỏ trống !',
      };
    } else {
      this.modelTemplate.TEMPLATE_NAME = this.modelTemplate.TEMPLATE_NAME.trim();
      this.emailService.createTemplate(this.modelTemplate).subscribe(
        res => {
          if (res) {
            const error = res.error;
            if (error) {
              this.message = {
                class: 'alert dark alert-danger',
                content: 'Thêm mới không thành công',
              };
              this.toastr.error('Thêm mới thất bại', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
            } else {
              this.message = {
                class: 'alert dark alert-success',
                content: 'Thêm mới thành công',
              };
              this.toastr.success('Thêm mới thành công', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });

              this.loadTemplate();
              this.modalRef.hide();
            }
          }
        },
        error => {
          this.message = {
            class: 'alert dark alert-danger',
            content: error.message,
          };
        }
      );
    }
  }

  editTemplate() {
    this.message = null;
    if (
      !this.modelTemplate.TEMPLATE_NAME ||
      (this.modelTemplate.TEMPLATE_NAME && this.modelTemplate.TEMPLATE_NAME.trim() == '')
    ) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Tên không được bỏ trống !',
      };
    } else {
      this.modelTemplate.TEMPLATE_NAME = this.modelTemplate.TEMPLATE_NAME.trim();
      const payload = _.assign({}, this.modelTemplate);

      delete payload.ID;
      delete payload.CREATED_DATE;
      delete payload.USER_CREATED;
      delete payload.TENANT_ID;
      this.emailService.updateTemplate(this.modelTemplate.ID, payload).subscribe(
        res => {
          if (res) {
            const error = res.error;
            if (error) {
              this.message = {
                class: 'alert dark alert-danger',
                content: 'Cập nhật không thành công',
              };
              this.toastr.error('Cập nhật thất bại', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
            } else {
              this.message = {
                class: 'alert dark alert-success',
                content: 'Cập nhật thành công',
              };
              this.toastr.success('Cập nhật thành công', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
              this.loadTemplate();
              this.modalRef.hide();
            }
          }
        },
        error => {
          this.message = {
            class: 'alert dark alert-danger',
            content: error.message,
          };
        }
      );
    }
  }

  changeFile($event) {
    const files = $event.srcElement.files;
    this.uploadService.upload(files[0]).then((res: any) => {
      if (!res.error) {
        this.files.push(res.data);
        this.modelTemplate['ATTACH_FILE'] = this.files.join(',');
        $event.target.value = null;
      } else {
        this.toastr.error(res.data.message, 'Lỗi', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
      }
    });
  }

  deleteFile(file) {
    this.files = _.pull(this.files, file);
    this.modelTemplate['ATTACH_FILE'] = this.files.join(',');
  }

  openConfirmDelete(template: TemplateRef<any>, id) {
    this.id_delete = id;
    // this.modalRef2 = this.modalService.show(template);
    const y = confirm('Bạn có muốn xóa không?');
    if (y) {
      this.submitDelete();
    }
  }

  submitDelete() {
    if (this.tab == 'template') {
      this.emailService.deleteTemplate(this.id_delete).subscribe(
        res => {
          if (res) {
            const error = res.error;
            if (error) {
              this.message = {
                class: 'alert dark alert-danger',
                content: 'Xóa không thành công',
              };
              this.toastr.error('Xóa không thành công', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
            } else {
              this.message = {
                class: 'alert dark alert-success',
                content: 'Xóa thành công',
              };
              this.toastr.success('Xóa thành công', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
              this.loadTemplate();
              // this.modalRef2.hide();
            }
          }
        },
        error => {
          this.message = {
            class: 'alert dark alert-danger',
            content: error.message,
          };
        }
      );
    } else {
      this.emailService.deleteAccount(this.id_delete).subscribe(
        res => {
          if (res) {
            const error = res.error;
            if (error) {
              this.message = {
                class: 'alert dark alert-danger',
                content: 'Xóa không thành công',
              };
              this.toastr.error('Xóa không thành công', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
            } else {
              this.message = {
                class: 'alert dark alert-success',
                content: 'Xóa thành công',
              };
              this.toastr.success('Xóa thành công', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
              this.loadAccount();
              // this.modalRef2.hide();
            }
          }
        },
        error => {
          this.message = {
            class: 'alert dark alert-danger',
            content: error.message,
          };
        }
      );
    }
  }

  openModal(template: TemplateRef<any>, id?: any) {
    this.allType = [
      { id: '', text: '' },
      {
        id: '0',
        text: 'Tập thể',
      },
      {
        id: '1',
        text: 'Cá nhân',
      },
    ];
    this.loadTemplate();
    this.message = null;
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
    };
    this.modalRef = this.modalService.show(template, config);
    this.model = {};
    this.typeModal = id ? 'edit' : 'add';
    if (id) {
      this.emailService
        .findAccount(id)
        .toPromise()
        .then(rs => {
          console.log(id, rs.data);
          this.model = rs.data;
        });
    }
  }

  changedTypeAccount($event) {
    this.model['account_type'] = $event.value;
  }

  changedTemplate($event: any) {
    this.model['AUTO_REPLY_EMAIL_TEMPLATE_ID'] = $event.value;
  }

  add() {
    console.log(this.model);
    if (!this.model.EMAIL_ADDRESS || (this.model.EMAIL_ADDRESS && this.model.EMAIL_ADDRESS.trim() == '')) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Địa chỉ không được bỏ trống !',
      };
    } else if (
      !this.model.INCOMING_PASSWORD ||
      (this.model.INCOMING_PASSWORD && this.model.INCOMING_PASSWORD.trim() == '')
    ) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Mật khẩu không được bỏ trống !',
      };
    } else if (!this.model.INCOMING_SERVER || (this.model.INCOMING_SERVER && this.model.INCOMING_SERVER.trim() == '')) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Địa chỉ server INCOMING không được bỏ trống !',
      };
    } else if (!this.model.INCOMING_SERVER_PORT) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Port INCOMING không được bỏ trống !',
      };
    } else if (
      !this.model.INCOMING_SERVER_AUTH ||
      (this.model.INCOMING_SERVER_AUTH && this.model.INCOMING_SERVER_AUTH.trim() == '')
    ) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Xác thực INCOMING không được bỏ trống !',
      };
    } else if (
      !this.model.INCOMING_SERVER_PROTOCOL ||
      (this.model.INCOMING_SERVER_PROTOCOL && this.model.INCOMING_SERVER_PROTOCOL.trim() == '')
    ) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Giao thức INCOMING không được bỏ trống !',
      };
    } else if (
      !this.model.OUTGOING_EMAIL_ADDRESS ||
      (this.model.OUTGOING_EMAIL_ADDRESS && this.model.OUTGOING_EMAIL_ADDRESS.trim() == '')
    ) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Địa chỉ không được bỏ trống !',
      };
    } else if (
      !this.model.OUTGOING_PASSWORD ||
      (this.model.OUTGOING_PASSWORD && this.model.OUTGOING_PASSWORD.trim() == '')
    ) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Mật khẩu không được bỏ trống !',
      };
    } else if (!this.model.OUTGOING_SERVER || (this.model.OUTGOING_SERVER && this.model.OUTGOING_SERVER.trim() == '')) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Địa chỉ server OUTGOING không được bỏ trống !',
      };
    } else if (!this.model.OUTGOING_SERVER_PORT) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Port OUTGOING không được bỏ trống !',
      };
    } else if (
      !this.model.OUTGOING_SERVER_AUTH ||
      (this.model.OUTGOING_SERVER_AUTH && this.model.OUTGOING_SERVER_AUTH.trim() == '')
    ) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Xác thực OUTGOING không được bỏ trống !',
      };
    } else if (
      !this.model.OUTGOING_SERVER_PROTOCOL ||
      (this.model.OUTGOING_SERVER_PROTOCOL && this.model.OUTGOING_SERVER_PROTOCOL.trim() == '')
    ) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Giao thức OUTGOING không được bỏ trống !',
      };
    } else if (!this.model.ACCOUNT_NAME || (this.model.ACCOUNT_NAME && this.model.ACCOUNT_NAME.trim() == '')) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Tên tài khoản không được bỏ trống !',
      };
    } else if (!this.model.account_type) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Loại tài khoản không được bỏ trống !',
      };
    } else {
      this.model.EMAIL_ADDRESS = this.model.EMAIL_ADDRESS.trim();
      this.model.INCOMING_SERVER = this.model.INCOMING_SERVER.trim();
      this.model.INCOMING_SERVER_AUTH = this.model.INCOMING_SERVER_AUTH.trim();
      // this.model.INCOMING_SERVER_PORT = this.model.INCOMING_SERVER_PORT.trim();
      this.model.INCOMING_SERVER_PROTOCOL = this.model.INCOMING_SERVER_PROTOCOL.trim();
      this.model.OUTGOING_EMAIL_ADDRESS = this.model.OUTGOING_EMAIL_ADDRESS.trim();
      this.model.OUTGOING_SERVER = this.model.OUTGOING_SERVER.trim();
      this.model.OUTGOING_SERVER_AUTH = this.model.OUTGOING_SERVER_AUTH.trim();
      // this.model.OUTGOING_SERVER_PORT = this.model.OUTGOING_SERVER_PORT.trim();
      this.model.OUTGOING_SERVER_PROTOCOL = this.model.OUTGOING_SERVER_PROTOCOL.trim();
      const payload = _.assign({}, this.model);
      payload['AUTO_REPLY_EMAIL'] = this.model['AUTO_REPLY_EMAIL'] ? 1 : 0;
      if (!this.model['AUTO_REPLY_EMAIL']) {
        payload['AUTO_REPLY_EMAIL_TEMPLATE_ID'] = '';
      }
      this.emailService.createAccount(payload).subscribe(
        res => {
          if (res) {
            const error = res.error;
            if (error) {
              this.message = {
                class: 'alert dark alert-danger',
                content: 'Thêm mới không thành công',
              };
              this.toastr.error('Thêm mới thất bại', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
            } else {
              this.message = {
                class: 'alert dark alert-success',
                content: 'Thêm mới thành công',
              };
              this.toastr.success('Thêm mới thành công', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });

              this.loadAccount();
              this.modalRef.hide();
            }
          }
        },
        error => {
          this.message = {
            class: 'alert dark alert-danger',
            content: error.message,
          };
        }
      );
    }
  }

  edit() {
    this.message = null;
    if (!this.model.EMAIL_ADDRESS || (this.model.EMAIL_ADDRESS && this.model.EMAIL_ADDRESS.trim() == '')) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Địa chỉ không được bỏ trống !',
      };
    } else if (
      !this.model.INCOMING_PASSWORD ||
      (this.model.INCOMING_PASSWORD && this.model.INCOMING_PASSWORD.trim() == '')
    ) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Mật khẩu không được bỏ trống !',
      };
    } else if (!this.model.INCOMING_SERVER || (this.model.INCOMING_SERVER && this.model.INCOMING_SERVER.trim() == '')) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Địa chỉ server INCOMING không được bỏ trống !',
      };
    } else if (!this.model.INCOMING_SERVER_PORT) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Port INCOMING không được bỏ trống !',
      };
    } else if (
      !this.model.INCOMING_SERVER_AUTH ||
      (this.model.INCOMING_SERVER_AUTH && this.model.INCOMING_SERVER_AUTH.trim() == '')
    ) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Xác thực INCOMING không được bỏ trống !',
      };
    } else if (
      !this.model.INCOMING_SERVER_PROTOCOL ||
      (this.model.INCOMING_SERVER_PROTOCOL && this.model.INCOMING_SERVER_PROTOCOL.trim() == '')
    ) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Giao thức INCOMING không được bỏ trống !',
      };
    } else if (
      !this.model.OUTGOING_EMAIL_ADDRESS ||
      (this.model.OUTGOING_EMAIL_ADDRESS && this.model.OUTGOING_EMAIL_ADDRESS.trim() == '')
    ) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Địa chỉ không được bỏ trống !',
      };
    } else if (
      !this.model.OUTGOING_PASSWORD ||
      (this.model.OUTGOING_PASSWORD && this.model.OUTGOING_PASSWORD.trim() == '')
    ) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Mật khẩu không được bỏ trống !',
      };
    } else if (!this.model.OUTGOING_SERVER || (this.model.OUTGOING_SERVER && this.model.OUTGOING_SERVER.trim() == '')) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Địa chỉ server OUTGOING không được bỏ trống !',
      };
    } else if (!this.model.OUTGOING_SERVER_PORT) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Port OUTGOING không được bỏ trống !',
      };
    } else if (
      !this.model.OUTGOING_SERVER_AUTH ||
      (this.model.OUTGOING_SERVER_AUTH && this.model.OUTGOING_SERVER_AUTH.trim() == '')
    ) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Xác thực OUTGOING không được bỏ trống !',
      };
    } else if (
      !this.model.OUTGOING_SERVER_PROTOCOL ||
      (this.model.OUTGOING_SERVER_PROTOCOL && this.model.OUTGOING_SERVER_PROTOCOL.trim() == '')
    ) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Giao thức OUTGOING không được bỏ trống !',
      };
    } else if (!this.model.ACCOUNT_NAME || (this.model.ACCOUNT_NAME && this.model.ACCOUNT_NAME.trim() == '')) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Tên tài khoản không được bỏ trống !',
      };
    } else if (!this.model.account_type) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Loại tài khoản không được bỏ trống !',
      };
    } else {
      this.model.EMAIL_ADDRESS = this.model.EMAIL_ADDRESS.trim();
      this.model.INCOMING_SERVER = this.model.INCOMING_SERVER.trim();
      this.model.INCOMING_SERVER_AUTH = this.model.INCOMING_SERVER_AUTH.trim();
      // this.model.INCOMING_SERVER_PORT = this.model.INCOMING_SERVER_PORT.trim();
      this.model.INCOMING_SERVER_PROTOCOL = this.model.INCOMING_SERVER_PROTOCOL.trim();
      this.model.OUTGOING_EMAIL_ADDRESS = this.model.OUTGOING_EMAIL_ADDRESS.trim();
      this.model.OUTGOING_SERVER = this.model.OUTGOING_SERVER.trim();
      this.model.OUTGOING_SERVER_AUTH = this.model.OUTGOING_SERVER_AUTH.trim();
      // this.model.OUTGOING_SERVER_PORT = this.model.OUTGOING_SERVER_PORT.trim();
      this.model.OUTGOING_SERVER_PROTOCOL = this.model.OUTGOING_SERVER_PROTOCOL.trim();

      const payload = _.assign({}, this.model);
      payload['AUTO_REPLY_EMAIL'] = this.model['AUTO_REPLY_EMAIL'] ? 1 : 0;
      if (!this.model['AUTO_REPLY_EMAIL']) {
        payload['AUTO_REPLY_EMAIL_TEMPLATE_ID'] = '';
      }
      delete payload.ID;
      delete payload.CREATED_DATE;
      delete payload.USER_CREATED;
      delete payload.TENANT_ID;
      delete payload.INCOMING_STATUS;
      delete payload.SERVICE_GROUP;
      delete payload.OUTGOING_STATUS;
      this.emailService.updateAccount(this.model.ID, payload).subscribe(
        res => {
          if (res) {
            const error = res.error;
            if (error) {
              this.message = {
                class: 'alert dark alert-danger',
                content: 'Cập nhật không thành công',
              };
              this.toastr.error('Cập nhật thất bại', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
            } else {
              this.message = {
                class: 'alert dark alert-success',
                content: 'Cập nhật thành công',
              };
              this.toastr.success('Cập nhật thành công', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
              this.loadAccount();
              this.modalRef.hide();
            }
          }
        },
        error => {
          this.message = {
            class: 'alert dark alert-danger',
            content: error.message,
          };
        }
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/email/mail.component.ts